/**
 * @module BrowseRoles
 */
// eslint-disable-next-line no-unused-vars
import React from 'react';
import TeamSelector from './TeamSelector';
import { STRINGS } from '../helpers/strings';

/**
 * Represents the Browse Roles section for Careers pages.
 *
 * @param {object} props - The component props object.
 * @param {string} props.jobTeam - Optional team name of a job, used for filtering to a specific team.
 * @param {Array<Team>} props.teams - Array of team data objects.
 *
 * @returns {React.ReactElement} The BrowseRoles component.
 */
export default function BrowseRoles({ jobTeam, teams }) {
  return (
    <div className="browser-roles text-center" data-testid="lc-browse-roles">
      <h1 className="text-title">{STRINGS.roles.findFit}</h1>
      <h2 className="text-subhead mb-relaxed">
        {STRINGS.roles.browseAllRoles}
      </h2>
      <TeamSelector jobTeam={jobTeam} teams={teams} />
    </div>
  );
}
